import { render } from "./ShippingType.vue?vue&type=template&id=6ef0cd86"
import script from "./ShippingType.vue?vue&type=script&lang=js"
export * from "./ShippingType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__